import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ToastComponent} from './toast.component';

export interface ToastParams {
  isHeader?: boolean;
  title?: string;
  subtitle?: string;
  autoHideDelay?: number;
  autoHide?: boolean;
  message: string;
  classes?: string[];
  position?: {[key: string] : string};
}

@NgModule({
  declarations: [ToastComponent],
  imports: [
    CommonModule
  ],
  exports: [ToastComponent]
})
export class ToastModule {
}
